div(class="node {{isSelected(node)?'selected':''}} {{toClassName(node.name)}}")
  div.title
    | {{node.name}}

  // Outputs
  div(al-repeat='output in Array.from(node.outputs.values())',style="text-align: right")
    .output-title
      | {{output.name}}
    .socket.output(
      al-socket="output", 
      class="{{toClassName(output.socket.name)}}",
      title='{{output.socket.name}}\n{{output.socket.hint}}'
    )

  // Controls
  div.control(
    al-repeat='control in Array.from(node.controls.values())',
    al-control
  )

  // Inputs
  div(al-repeat='input in Array.from(node.inputs.values())',style="text-align: left")
    .socket.input(
      al-socket="input",
      class="{{toClassName(input.socket.name)}} {{input.multipleConnections?'multiple':''}}"
      title='{{input.socket.name}}'
    )
    .input-title(
      al-if='!input.showControl()'
    )
      | {{input.name}}
    .input-control(
      al-if='input.showControl()'
      al-control
    )